import { useAnimatedValue } from '../../hooks/useAnimatedValue';

interface AnimatedNumberProps {
  value: number;
  formatter: (v: number) => string;
  className?: string;
}

export function AnimatedNumber({ value, formatter, className = '' }: AnimatedNumberProps) {
  const decimals = Math.abs(value) < 1 && value !== 0 ? 4 : 0;
  const animated = useAnimatedValue(value, { decimals });
  return (
    <span className={`tabular-nums ${className}`}>
      {formatter(animated)}
    </span>
  );
}
